import Text from 'components/shared/Text'
import { Wrapper } from './styles'
import Box from 'components/shared/Box'
import { FormattedMessage } from 'react-intl'
import Link from 'components/shared/Link'
import { useResolutions } from 'store/resolutions'
import palm from 'assets/icons/palm.svg'
import Section from 'components/shared/Section'

interface OfferErrorProps {
    hasCta?: boolean
    onCtaClick?: () => void
}

const OfferError = ({ hasCta, onCtaClick }: OfferErrorProps) => {
    const { isTablet } = useResolutions()

    const formatedMessageChunks = {
        span: (chunks: string[]) => (
            <Text as="span" variant="body" color="grayscale_900" mb={[0, 12]}>
                {chunks}
            </Text>
        ),
        button: (chunks: string[]) => (
            <>
                {isTablet && <br />}
                <Link
                    variant="primary"
                    onClick={onCtaClick}
                    data-testid={
                        'accommo-message-button-continue-without-accommo'
                    }
                >
                    {chunks}
                </Link>
            </>
        ),
    }
    return (
        <Section id={'accommodation-bungalows-error'}>
            <Wrapper
                padding={32}
                direction={['column', 'row']}
                gap={[16, 32]}
                align="center"
            >
                <Box>
                    <img src={palm} alt="" />
                </Box>
                <Box align={['center', 'flex-start']}>
                    <Text
                        variant="heading4"
                        color="secondary_500"
                        mb={[24, 12]}
                    >
                        <FormattedMessage
                            id="accommodation.offer_error.info"
                            defaultMessage="Przepraszamy, mamy problem techniczny"
                        />
                    </Text>
                    <Text variant="body" color="grayscale_900">
                        {hasCta ? (
                            <FormattedMessage
                                id="accommodation.offer_error.copy"
                                defaultMessage="<span>Wyszukanie noclegu nie jest teraz możliwe. </span>Spróbuj ponownie później lub <button>kontynuuj bez noclegu</button>"
                                values={formatedMessageChunks}
                            />
                        ) : (
                            <FormattedMessage
                                id="accommodation.offer_error.copy_actionless"
                                defaultMessage="<span>Wyszukanie noclegu nie jest teraz możliwe. </span>Spróbuj ponownie później."
                                values={formatedMessageChunks}
                            />
                        )}
                    </Text>
                </Box>
            </Wrapper>
        </Section>
    )
}

export default OfferError
